import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFriendRequest = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL; 

    const postFriendRequest = async (friendRequestPayload) => {
        try {
            const token = await getAccessTokenSilently({
                authorizationParams: {
                    audience: process.env.REACT_APP_API_AUDIENCE,
                },
            });

            const response = await fetch(`${apiUrl}/api/friends`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(friendRequestPayload),
            });

            if (!response.ok) {
                throw new Error('Failed to submit friend request');
            }
            setError(null);
            return true;
        } catch (err) {
            setError(err.message);
        }

        return false;
    };

    return {
        postFriendRequest,
        sendFriendRequest: postFriendRequest,
        error,
    };
};
